module.exports = __webpack_public_path__ + "assets/img/informationDate.24f063cf.png";